import { render } from "./MAGate.vue?vue&type=template&id=ad373868"
import script from "./MAGate.vue?vue&type=script&lang=ts"
export * from "./MAGate.vue?vue&type=script&lang=ts"
script.render = render

export default script